import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import AOS from 'aos';
import 'bootstrap/scss/bootstrap.scss';
import 'aos/dist/aos.css';
import './App.css';
import './index.css';
import './fonts/stylesheet.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const Root = () => {
  useEffect(() => {
    setTimeout(() => {
      AOS.init({
        duration: 1200, 
      });
    },); 
  }, []);

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
